export enum VideoType {
    m3u8 = 'application/x-mpegURL',
    hls = 'application/x-mpegURL',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/media/enums.ts